export const primaryPhoneTypes = [
  'Mobile',
  'Home', //
];

export const suffix = [
  'Jr.',
  'Sr.',
  'II',
  'III',
  'IV',
  'V', //
];

export const maritalStatuses = [
  'Single',
  'Married',
  'Separated', //
];

export const usStates = [
  'AL',
  'AK',
  'AZ',
  'AR',
  'CA',
  'CO',
  'CT',
  'DC',
  'DE',
  'FL',
  'GA',
  'HI',
  'ID',
  'IL',
  'IN',
  'IA',
  'KS',
  'KY',
  'LA',
  'ME',
  'MD',
  'MA',
  'MI',
  'MN',
  'MS',
  'MO',
  'MT',
  'NE',
  'NV',
  'NH',
  'NJ',
  'NM',
  'NY',
  'NC',
  'ND',
  'OH',
  'OK',
  'OR',
  'PA',
  'RI',
  'SC',
  'SD',
  'TN',
  'TX',
  'UT',
  'VT',
  'VA',
  'WA',
  'WV',
  'WI',
  'WY',
];

export const statusesAtAddress = [
  'Own/Buying',
  'Rent',
  'with Relatives',
  'with Friends', //
];

export const employmentTypes = [
  'Employed',
  'Home-Maker',
  'Military', //
];

export const additionalIncomeSources = [
  'Social Security',
  'VA Disability',
  'Pension',
  'Rental Properties',
  'Other', //
];

export const sellerTypes = [
  'Dealer',
  'Private Party', //
];

export const legalEntityTypes = [
  'Sole Proprietorship',
  'Partnership',
  'LLC',
  'Corporation',
  'Non-Profit',
  'Other', //
];

export const citizenshipStatuses = [
  'US Citizen',
  'Permanent Resident',
  'Resident Alien',
  'Other', //
];
